import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, withLatestFrom, switchMap } from 'rxjs/operators';
import { MarketDrawerRootReducerState } from '../reducer';
import { MarketsService } from '../../services/markets.service';
import { MarketView } from '../../models/markets';
import {
  MARKETS_LOAD_REQUESTED,
  MarketsLoadSuccessAction,
  MarketsLoadErrorAction
} from './actions';

@Injectable()
export class MarketsEffects {
  @Effect()
  public loadMarkets$: Observable<
    MarketsLoadSuccessAction | MarketsLoadErrorAction
  > = this.actions.pipe(
    ofType(MARKETS_LOAD_REQUESTED),
    withLatestFrom(this.store),
    switchMap(
      ([action, state]): Observable<
        MarketsLoadSuccessAction | MarketsLoadErrorAction
      > =>
        this.marketsService.fetchData(state.marketDrawer.dealDate).pipe(
          map((markets: MarketView[]) => new MarketsLoadSuccessAction(markets)),
          catchError((error: Error) =>
            of(new MarketsLoadErrorAction(error.message))
          )
        )
    )
  );

  constructor(
    private store: Store<MarketDrawerRootReducerState>,
    private actions: Actions,
    public marketsService: MarketsService
  ) {}
}
